;(function ($) {
  "use strict";

  $('form.js-substance-search').submit(function trackSubstanceSearchSubmission() {
    var term = $('form.js-substance-search input.js-substance-search-input').val();

    dataLayer.push({
      'event': 'trackEvent',
      'eventName': 'search',
      'search.type': 'search submit',
      'search.term': term
    });
  });

  $('.js-alphabet-navigation-character').click(function trackSubstanceAlphabetLinkClick() {
    var character = $(this).text();

    dataLayer.push({
      'event': 'trackEvent',
      'eventName': 'search',
      'search.type' : 'browse alphabetically',
      'search.searchTerm': character,
    });
  });

  $('.js-document-link-click').click(function trackDocumentLinkClick() {
    var link = $(this).attr('href');

    dataLayer.push({
      'event': 'trackEvent',
      'eventName': 'document_link_click',
      'eventDetail': 'Document Link click',
      'destinationUrl': link,
    });
  });
})(jQuery);
